/**
 Validates org numbers from Denmark, e.g. 12345678
 */
export const validateDenmarkOrgNumber = (number: string) => {
  const denmarkOrgNumberRegex = /^\d{8}$/g;

  return denmarkOrgNumberRegex.test(number);
};
